import React, { useEffect, useState } from 'react';
import styles from './RequestDetails.module.scss';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentPage, requestsSelector, setActiveTab, updateRequestPages } from '../../../redux/slicers/requestSlicer';
import { Tab, Tabs } from 'react-bootstrap';
import FullProduct from './FullProduct';
import CloseUp from './CloseUp';
import OtherReferences from './OtherReferences';
import Tips from '../../../components/Request/Tips';

import CLOSE_UP_1 from '../../../assets/images/requests/close_up_1.png';
import CLOSE_UP_2 from '../../../assets/images/requests/close_up_2.png';
import CLOSE_UP_3 from '../../../assets/images/requests/close_up_3.png';

function Images() {
  const _requestSelector = useSelector(requestsSelector);
  const currentPage = useSelector(getCurrentPage);

  const dispatch = useDispatch();

  const TIP_TEXT_1 =
    "These formats are compatible with 'FullProduct': jpeg, jpg, png, tiff, webp. \n\n For the best results in creating the 3D model, it's helpful if the pictures are taken straight-on at eye level. Clear, high-quality images (at least 2k resolution) show all the details and let us accurately recreate the product in 3D.\n\nThis process ensures accurate proportions and a true-to-life virtual representation\n\nMax upload limit is 1.5 GB";

  const TIP_TEXT_2 =
    'These formats are compatible with "Close Up": jpeg, jpg, png, tiff, webp.\n\nPlease click closeups images of details you want us to focus on, such as tufting, stitching, legs and so on.';

  const TIP_TEXT_3 =
    'These formats are compatible with "OtherReference": All formats. \n\nAdd more product images to showcase the construction, structure & how your product look from different angles. This help us visualize your product better.\n\n\nYou can attach other files too like cad, fbx, glb or weblink.';

  const [tip, setTip] = useState(TIP_TEXT_1);

  const handleTabChange = (e) => {
    dispatch(setActiveTab(e));
  };

  useEffect(() => {
    if (_requestSelector.activeTab === 'product') setTip(TIP_TEXT_1);
    else if (_requestSelector.activeTab === 'closeUp') setTip(TIP_TEXT_2);
    else setTip(TIP_TEXT_3);
  }, [_requestSelector.activeTab]);

  return (
    <div
      className={cx('d-flex flex-column justify-content-center align-items-start', styles.wrapper)}>
      <h2 className="px-5">Add photos of {_requestSelector.requestName}</h2>
      <div className={cx('d-flex align-items-center', styles.bodyWrapper)}>
        <div className={cx('mySettings', styles.mySettings)}>
          <div className={cx('setting-tabs', styles.settingTab)}>
            <Tabs
              className={styles.topTabs}
              mountOnEnter
              activeKey={_requestSelector.activeTab}
              onSelect={handleTabChange}>
              <Tab eventKey="product" title="Full Product">
                <FullProduct className={styles.FullProduct} />
              </Tab>
              <Tab eventKey="closeUp" title="Close Up">
                <CloseUp />
              </Tab>
              <Tab eventKey="other" title="Other References">
                <OtherReferences />
              </Tab>
            </Tabs>
          </div>
        </div>
        <Tips
          title="Images"
          text={tip}
          marginTop={5}
          showImages={tip !== TIP_TEXT_2}
          customImages={tip === TIP_TEXT_2 ? [CLOSE_UP_1, CLOSE_UP_2, CLOSE_UP_3] : null}
        />
      </div>
    </div>
  );
}

export default Images;
